import { useQueryClient, useQuery, useMutation } from "@tanstack/react-query";
import { notification, Button, Row, Divider, Col, Table, Modal, Input } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { deletePlaceholder, getLanguages, getTranslations } from "../../services/api";
import { DeleteOutlined, FileAddOutlined } from '@ant-design/icons';
import { TableLanguage } from "../../styles/global";
import PageTitle from "../../components/page-title";
const { Search } = Input;

const Placeholders = () => {
    const queryClient = useQueryClient();
    const [ searchTerm, setSearchTerm ] = useState('');
    const [ ntf, contextHolder ] = notification.useNotification();
    const { data, isFetched } = useQuery(['placeholders', {search: searchTerm}], () => getTranslations(), {select: (data) => {
      const filteredData = data.filter((item: any) =>
        item.key_holder.toLowerCase().includes(searchTerm.toLowerCase())
      );
      return filteredData;
    }});
    const { data: dataLanguages, isLoading: isLoadingLanguages } = useQuery(['languages'], () => getLanguages(), {cacheTime: 120000, staleTime: 120000});
    const { mutate: mutateDeletePlaceholder } = useMutation(deletePlaceholder)
    const [ isOpenDeleteArticleModal, setisOpenDeleteArticleModal ] = useState({open: false, id: 0});
  
    const handleDelete = () => {
      mutateDeletePlaceholder({id: isOpenDeleteArticleModal.id}, {
        onSuccess() {
          queryClient.invalidateQueries(['placeholders']);
          setisOpenDeleteArticleModal({open: false, id: 0});
          ntf.success({
            message: `Success`,
            description: "Blog is deleted with success!",
            placement: "bottomLeft",
          });
        },
        onError() {
          ntf.error({
            message: `Error`,
            description: "Something gonne wrong!",
            placement: "bottomLeft",
          });
        },
      })
    }

    const showLanguage = (langId: string) => {
      const result = dataLanguages && dataLanguages.find((language: any) => language.id === langId);
      return {...result};
    }
  
    const columns: any = [
      {
        title: 'Key Id',
        dataIndex: 'id',
        key: 'id',
      },
      {
        title: 'Placeholder Key',
        dataIndex: 'key_holder',
        key: 'key_holder',
        render: (key: string, record: any) => <Link to={`/placeholders/${record.id}`}>{key}</Link>
      },
      {
        title: 'Language',
        dataIndex: 'language_id',
        key: 'language_id',
        render: (key: string, record: any) => showLanguage(key).name ? <TableLanguage>{showLanguage(key).name}</TableLanguage> : <TableLanguage notSet={true}>not set</TableLanguage>
      },
      {
        title: 'Date Added',
        dataIndex: 'date_added',
        key: 'date_added'
      },
      {
        title: 'Delete',
        dataIndex: 'delete',
        key: 'delete',
        align: 'center',
        width: '50px',
        render: (id: any, record: any) => <Button icon={<DeleteOutlined />} danger onClick={() => setisOpenDeleteArticleModal({open: true, id: record.id})} />
      },
    ];
    
  
    return (
      <Row justify="center">
        {contextHolder}
        <PageTitle text={`Placeholders`} />
        <Col span={20}>
            <Row gutter={24}>
                <Col>
                    <Link to="/placeholders/create">
                        <Button type="primary" icon={<FileAddOutlined />}>Create Placeholder</Button>
                    </Link>
                </Col>
                <Col>
                    <Search
                      placeholder="Search by placeholder key"
                      onSearch={(value) => setSearchTerm(value)}
                      style={{ width: 300 }}
                    />
                </Col>
            </Row>
        </Col>
        <Col span={20}>
          <Table dataSource={isFetched ? data : []} columns={columns} pagination={false} rowKey='id'/>;
        </Col>
        <Modal title="Delete Blog?" open={isOpenDeleteArticleModal.open} onOk={() => handleDelete()} onCancel={() => setisOpenDeleteArticleModal({open: false, id: 0})}>
          Do you really want to delete it?
        </Modal>
      </Row>
    )
  }
  
  export default Placeholders